if (!customElements.get('ll-hero-gallery')) {
  customElements.define('ll-hero-gallery', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ll-gallery__track');
      this.slides = [...this.querySelectorAll('.ll-gallery__slide')];
      if (!this.track || !this.slides.length) return;
      this.active = 0;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('[data-controls]').hidden = this.slides.length < 2;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-direction')) this.goTo(this.active + Number(button.dataset.direction));
      }, options);
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.active + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }, { ...options, passive: true });
      this.resize = new ResizeObserver(() => {
        this.track.scrollTo({ left: this.slides[this.active].offsetLeft, behavior: 'instant' });
      });
      this.resize.observe(this.track);
      this.update(0);
    }

    goTo(index) {
      const target = (index + this.slides.length) % this.slides.length;
      this.track.scrollTo({
        left: this.slides[target].offsetLeft,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    sync() {
      const index = this.slides.reduce((nearest, slide, current) =>
        Math.abs(slide.offsetLeft - this.track.scrollLeft) <
        Math.abs(this.slides[nearest].offsetLeft - this.track.scrollLeft) ? current : nearest, 0);
      if (index !== this.active) this.update(index);
    }

    update(index) {
      this.active = index;
      this.slides.forEach((slide, current) => {
        slide.inert = current !== index;
        slide.setAttribute('aria-hidden', String(current !== index));
      });
      this.querySelector('[data-count]').textContent = `${index + 1} / ${this.slides.length}`;
      this.querySelector('[data-status]').textContent = this.slides[index].dataset.title;
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
